import { AndromedaMenuItem } from '@ansys-internal/awf-angular/contributions';
import { Icons } from '@ansys-internal/awc-angular/icons';
import { DialogService } from '@ansys-internal/awf-angular/shared';
import { ProjectData } from '@ansys/cloud-angular-client';
import { ProjectRenameDialogComponent } from '../../../../components/dialogs/project-rename-dialog/project-rename-dialog.component';
import { AWFMenuItem } from '@ansys-internal/awf-angular/core';

@AWFMenuItem({
  id: 'edit-files',
  priority: 200,
})
export class ProjectEditMenu implements AndromedaMenuItem {
  type = 'edit-files';
  priority = 200;
  id = 'edit-files';
  prefixIcon = {
    icon: Icons.EDIT,
  };
  text = 'Edit Project';

  constructor(
    private dialog: DialogService
  ) {}

  execute(context: ProjectData): Promise<void> {
    this.dialog.open(ProjectRenameDialogComponent, {
      title: 'Edit Project',
      data: {
        type: 'project',
        title: context?.projectTitle,
        goal: context?.projectGoal,
        id: context?.projectId,
      },
    });

    return Promise.resolve();
  }
  render(): AndromedaMenuItem {
    return this;
  }
}
